import { inject, Injectable } from '@angular/core';
import { CardResponse, DeleteCardResponse } from '../../interfaces/cards-response.interface';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiEndpoints } from '@app/utils/enums/api-endpoints';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class CardService {
  private http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  public getCards(): Observable<{ data: CardResponse[] }> {
    return this.http.get<{ data: CardResponse[] }>(
      `${this.baseUrl}${ApiEndpoints.BASE_PAYMENT_CARDS}`,
    );
  }

  public updateSelectedCard(paymentMethodId: string): Observable<void> {
    return this.http.put<void>(
      `${this.baseUrl}${ApiEndpoints.BASE_PAYMENT_CARDS}/${paymentMethodId}/set-default`,
      {},
    );
  }

  public deletePaymentMethod(stripePaymentMethodId: string): Observable<DeleteCardResponse> {
    return this.http.delete<DeleteCardResponse>(
      `${this.baseUrl}${ApiEndpoints.BASE_PAYMENT_CARDS}/${stripePaymentMethodId}`,
      {},
    );
  }

  public addPaymentMethod(cardType: string): Observable<void> {
    const paymentMethodId = `pm_card_${cardType}`;
    return this.http.post<void>(`${this.baseUrl}${ApiEndpoints.ADD_PAYMENT_METHOD}`, {
      paymentMethodId,
    });
  }
}
